"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeUtils = void 0;
var attr_1 = require("@devexpress/utils/lib/utils/attr");
var AttributeUtils = (function () {
    function AttributeUtils() {
    }
    AttributeUtils.changeElementStyleAttribute = function (obj, attrName, newValue) {
        attr_1.AttrUtils.saveStyleAttributeInElement(obj, attrName);
        AttributeUtils.setStyleAttribute(obj.style, attrName, newValue);
    };
    AttributeUtils.setStyleAttribute = function (obj, attrName, newValue) {
        if (obj.setAttribute)
            attr_1.AttrUtils.setElementAttribute(obj, attrName, newValue);
        else
            attr_1.AttrUtils.setStyleAttribute(obj, attrName, newValue);
    };
    return AttributeUtils;
}());
exports.AttributeUtils = AttributeUtils;
